import { Component, Injector } from "@angular/core";
import { FeatureName } from "@common/ADAPT.Common.Model/embed/feature-name.enum";
import { FeaturesService } from "@org-common/lib/features/features.service";
import { MeetingAgendaItemComponent } from "@org-common/lib/meetings/meeting-agenda-component-registry";
import { WorkshopSetCadenceBaseComponent } from "../workshop-set-cadence-base.component";

@MeetingAgendaItemComponent("adapt-pys-workshop-set-cadence")
@Component({
    selector: "adapt-pys-workshop-set-cadence",
    templateUrl: "./pys-workshop-set-cadence.component.html",
    standalone: false,
})
export class PysWorkshopSetCadenceComponent extends WorkshopSetCadenceBaseComponent {
    public hasCadenceFeature = false;
    public constructor(injector: Injector, featuresService: FeaturesService) {
        super(injector);
        this.hasCadenceFeature = featuresService.isFeatureEnabledForAccount(FeatureName.StewardshipWorkCadence);
    }
}
